import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

Scrivito.provideEditingConfig("EventsSliderWidget", {
  title: "Events Slider",
  attributes: localizeAttrList(
    ["eventCount", "slideInterval", "category", "eventLink"],
    "EventsSliderWidget"
  ),
  properties: ["eventCount", "slideInterval", "category", "eventLink"],
  initialContent: {
    eventCount: 10,
    slideInterval: 5000,
  },
});
